/// <amd-module name="SuiteCommerce.Blog.Post.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Post.Model", ["require", "exports", "SuiteCommerce.Blog.Common.PageTypeModel", "SuiteCommerce.Blog.Post.Configuration", "SuiteCommerce.Blog.DataProvider", "underscore", "SuiteCommerce.Blog.Common", "jQuery"], function (require, exports, PageTypeModel_1, Post_Configuration_1, DataProvider_1, _, Common_1, jQuery) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PostModel = /** @class */ (function (_super) {
        __extends(PostModel, _super);
        function PostModel(options) {
            var _this = _super.call(this, options) || this;
            if (options) {
                if (DataProvider_1.DataProvider.entitiesModel.isSync) {
                    _this.updateDataFromEntitiesBootstrapping();
                }
                _this.setupDataProviderListeners();
                _this.provideURLToImages();
                _this.fetchImageWithoutURLData();
            }
            else {
                _this.isDummy = true;
            }
            return _this;
        }
        PostModel.prototype.setupDataProviderListeners = function () {
            var _this = this;
            DataProvider_1.DataProvider.entitiesModel.on('change:isSync', function () {
                if (DataProvider_1.DataProvider.entitiesModel.isSync) {
                    _this.updateDataFromEntitiesBootstrapping();
                }
            });
            DataProvider_1.DataProvider.files.on('sync', function () {
                if (_this.imagesIdsWithoutUrl.length > 0) {
                    _this.provideURLToImages();
                }
            });
        };
        PostModel.prototype.updateDataFromEntitiesBootstrapping = function () {
            var category = DataProvider_1.DataProvider.categories.getCategoryById(this.category);
            var author = DataProvider_1.DataProvider.authors.getAuthorById(this.author);
            this.set('categoryName', category ? category.name : '');
            this.set('authorName', author ? author.name : '');
            if (DataProvider_1.DataProvider.entitiesModel.isSync &&
                ((this.category && !this.categoryName) ||
                    (this.author && !this.authorName))) {
                DataProvider_1.DataProvider.fetchEntitiesData();
            }
        };
        PostModel.prototype.fetchImageWithoutURLData = function () {
            var imagesIdsWithoutUrl = this.imagesIdsWithoutUrl;
            if (imagesIdsWithoutUrl.length > 0) {
                DataProvider_1.DataProvider.fetchFilesData(imagesIdsWithoutUrl);
            }
        };
        PostModel.prototype.provideURLToImages = function () {
            if (this.headerImageId && !this.headerImageURL) {
                this.provideURLToHeaderImage();
            }
        };
        PostModel.prototype.provideURLToHeaderImage = function () {
            var file = DataProvider_1.DataProvider.getFileById(this.headerImageId);
            if (file) {
                this.headerImageURL = file.url;
            }
        };
        Object.defineProperty(PostModel.prototype, "author", {
            get: function () {
                if (this.fields && this.fields.custrecord_sc_blog_post_pt_author) {
                    return "" + this.fields.custrecord_sc_blog_post_pt_author;
                }
                return '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "authorName", {
            get: function () {
                return this.get('authorName');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "authorUrl", {
            get: function () {
                if (this.author) {
                    var author = DataProvider_1.DataProvider.authors.getAuthorById(this.author);
                    return author
                        ? Common_1.BLOG_URL_BASE + "/" + Common_1.AvailableTaxonomies.author + "/" + author.urlComponent
                        : '';
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "category", {
            get: function () {
                if (this.fields && this.fields.custrecord_sc_blog_post_pt_post_category) {
                    return "" + this.fields.custrecord_sc_blog_post_pt_post_category;
                }
                return '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "categoryName", {
            get: function () {
                return this.get('categoryName');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "categoryURL", {
            get: function () {
                if (this.category) {
                    var category = DataProvider_1.DataProvider.categories.getCategoryById(this.category);
                    return category
                        ? Common_1.BLOG_URL_BASE + "/" + Common_1.AvailableTaxonomies.category + "/" + category.urlComponent
                        : '';
                }
                return;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "content", {
            get: function () {
                return this.fields ? this.fields.custrecord_sc_blog_post_pt_content : '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "excerpt", {
            get: function () {
                if (this.fields) {
                    if (this.fields.custrecord_sc_blog_post_pt_excerpt) {
                        return this.fields.custrecord_sc_blog_post_pt_excerpt;
                    }
                    if (this.content) {
                        var htmlNodes = jQuery("<div>" + this.content + "</div>");
                        var firstParagraphWithText_1 = '';
                        htmlNodes.find('p').each(function (index, paragraph) {
                            if (!firstParagraphWithText_1 && jQuery(paragraph).text().length > 0) {
                                firstParagraphWithText_1 = jQuery(paragraph).text();
                            }
                        });
                        return firstParagraphWithText_1 || this.content.split('<br />')[0];
                    }
                }
                return '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "headerImageAlt", {
            get: function () {
                return this.fields
                    ? this.fields.custrecord_sc_blog_post_pt_hdr_image_alt
                    : '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "headerImageResizeName", {
            get: function () {
                return Post_Configuration_1.PostConfiguration.largeImageResize
                    ? Post_Configuration_1.PostConfiguration.largeImageResize.name
                    : '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "headerImageId", {
            get: function () {
                if (this.fields && this.fields.custrecord_sc_blog_post_pt_header_image) {
                    return "" + this.fields.custrecord_sc_blog_post_pt_header_image;
                }
                return '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "headerImageURL", {
            get: function () {
                if (this.fields && this.headerImageId) {
                    return this.fields.custrecord_sc_blog_post_pt_header_image_url &&
                        this.fields.custrecord_sc_blog_post_pt_header_image_url.indexOf(this.headerImageId) !== -1
                        ? this.fields.custrecord_sc_blog_post_pt_header_image_url
                        : this.get('headerImageURL');
                }
                return;
            },
            set: function (url) {
                this.set('headerImageURL', url);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "imagesIdsWithoutUrl", {
            get: function () {
                var imagesIds = [];
                if (this.headerImageId && !this.headerImageURL) {
                    imagesIds.push(this.headerImageId);
                }
                return imagesIds;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "publishingDate", {
            get: function () {
                return this.fields && this.fields.custrecord_sc_blog_post_pt_pub_date
                    ? this.formatDate(this.fields.custrecord_sc_blog_post_pt_pub_date)
                    : '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "publishingDateUnformatted", {
            get: function () {
                return this.fields && this.fields.custrecord_sc_blog_post_pt_pub_date
                    ? this.fields.custrecord_sc_blog_post_pt_pub_date
                    : '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "subHeading", {
            get: function () {
                return this.fields ? this.fields.custrecord_sc_blog_post_pt_subheading : '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "tags", {
            get: function () {
                var tags = [];
                var unformattedTags = this.fields
                    ? this.fields.custrecord_sc_blog_post_pt_post_tags
                    : '';
                if (unformattedTags) {
                    _.each(unformattedTags.split(','), function (tag) {
                        tags.push(tag.trim());
                    });
                }
                return tags;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "thumbnailImageAlt", {
            get: function () {
                return this.fields
                    ? this.fields.custrecord_sc_blog_post_pt_timg_img_alt
                    : '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "thumbnailImageResizeName", {
            get: function () {
                return Post_Configuration_1.PostConfiguration.thumbnailImageResize
                    ? Post_Configuration_1.PostConfiguration.thumbnailImageResize.name
                    : '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "thumbnailImageURL", {
            get: function () {
                return this.fields
                    ? this.fields.custrecord_sc_blog_post_pt_thumbnail_img_url
                    : '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostModel.prototype, "isDummy", {
            get: function () {
                return this.get('isDummy');
            },
            set: function (isDummy) {
                this.set('isDummy', isDummy);
            },
            enumerable: true,
            configurable: true
        });
        PostModel.prototype.formatDate = function (receivedDate) {
            if (!!navigator.userAgent.match(/Trident/g) ||
                !!navigator.userAgent.match(/MSIE/g)) {
                return receivedDate;
            }
            var transformedDate = this.transformDateToSupportedFormat(receivedDate);
            if (transformedDate) {
                var dateObj = new Date(transformedDate);
                var dayOrdinal = this.getOrdinalForNumber(dateObj.getDate());
                var month = dateObj.toLocaleString('en-us', { month: 'long' });
                var day = dateObj.toLocaleString('en-us', { day: 'numeric' });
                var year = dateObj.toLocaleString('en-us', { year: 'numeric' });
                return month + " " + day + dayOrdinal + ", " + year;
            }
            return receivedDate;
        };
        PostModel.prototype.transformDateToSupportedFormat = function (stringDate) {
            switch (Post_Configuration_1.PostConfiguration.dateFormat) {
                case 'M/D/YYYY':
                case 'MM/DD/YYYY':
                case 'YYYY/MM/DD':
                case 'YYYY/M/D':
                case 'YYYY-M-D':
                    return stringDate;
                case 'D/M/YYYY':
                case 'DD/MM/YYYY':
                    return this.rearrangeDate(stringDate, '/');
                case 'D-Mon-YYYY':
                case 'D-MONTH-YYYY':
                case 'DD-Mon-YYYY':
                case 'DD-MONTH-YYYY':
                    return this.rearrangeDate(stringDate, '-');
                case 'D.M.YYYY':
                case 'DD.MM.YYYY':
                    return this.rearrangeDate(stringDate, '.');
                case 'D MONTH, YYYY':
                case 'DD MONTH, YYYY':
                    return this.rearrangeDate(stringDate, ' ');
                default:
                    return '';
            }
        };
        PostModel.prototype.rearrangeDate = function (date, separator) {
            var _a = date.split(separator), day = _a[0], month = _a[1], year = _a[2];
            return "" + month + separator + day + separator + year;
        };
        PostModel.prototype.getOrdinalForNumber = function (num) {
            return num > 0
                ? ['th', 'st', 'nd', 'rd'][(num > 3 && num < 21) || num % 10 > 3 ? 0 : num % 10]
                : '';
        };
        return PostModel;
    }(PageTypeModel_1.PageTypeModel));
    exports.PostModel = PostModel;
});
